<template>
  <div class="article-list">
    <h2 class="text-h3">{{ title }}</h2>
    <v-list role="list">
      <v-list-item
        class="article-list-item py-2 px-0"
        v-for="item in articleList"
        :key="item.articleId"
        tag="div"
        role="listitem"
      >
        <router-link
          :to="{ name: item.articleType.name, params: { pageName: item.slug } }"
          class="v-list-item v-list-item--link theme--light"
          :aria-label="'Vai all\'articolo: ' + item.title"
        >
          <v-list-item-avatar tile size="120" class="my-0 mr-2">
            <ebsn-media
              :cover="true"
              width="100%"
              :target="item"
              type="Article main"
              media="thumb"
              :alt="'Anteprima di ' + item.title"
              :aria-label="'Immagine anteprima per ' + item.title"
              onerror="this.src='/no-icon.png'"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </router-link>
      </v-list-item>
    </v-list>
  </div>
</template>
<style lang="scss">
.article-list {
  .article-list-item {
    border-bottom: 1px solid var(--v-grey-lighten3);
  }
}
</style>
<script>
export default {
  name: "ArticleAccordionList",
  props: {
    title: {
      type: String,
      required: false
    },
    articleList: {
      type: Array,
      required: true
    }
  }
};
</script>
